// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "spex-7177",
    "accountName": "development",
    "api_url": "https://sl5wb7z500.execute-api.eu-west-1.amazonaws.com/spex-7177/graphql",
    "notifications_api_url": "https://sl5wb7z500.execute-api.eu-west-1.amazonaws.com/spex-7177/notifications",
    "run_daily_test_url": "https://sadroeq8df.execute-api.eu-west-1.amazonaws.com/test/run-daily-test",
    "sport_highlights_url": "https://r365vowf6ngmxnnrthbo3spcxe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://sl5wb7z500.execute-api.eu-west-1.amazonaws.com/spex-7177/getConfig",
    "direct_appconfig_url": "https://ks5qi8b3ha.execute-api.eu-west-1.amazonaws.com/test",
		"endpoint_url" : "https://sl5wb7z500.execute-api.eu-west-1.amazonaws.com/spex-7177",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_d5uDD8Uzb",
    "aws_user_pools_web_client_id": "3sjkpls1po5uliqeltvjemci14",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-spex-7177.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.spex-7177.spex-dev.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.spex-7177.spex-dev.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://a9pdwyptjl.execute-api.eu-west-1.amazonaws.com/test",
    "arcusLicenseAcquisitionEndpointUrl": "https://7p3ij0h3x0.execute-api.eu-west-1.amazonaws.com/test",
    "viperProxyUrl": "https://d2xwajtvxxpc6j.cloudfront.net"
};

export default awsConfig;

